import { render, staticRenderFns } from "./Nav-bar.vue?vue&type=template&id=23bdd1a6&scoped=true&"
import script from "./Nav-bar.vue?vue&type=script&lang=js&"
export * from "./Nav-bar.vue?vue&type=script&lang=js&"
import style0 from "./Nav-bar.vue?vue&type=style&index=0&id=23bdd1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdd1a6",
  null
  
)

export default component.exports